import { formatMessage } from '@formosa/shared/i18n/formatMessage';

/**
 * 正規化 Center unread-count API payload（PD-NTF-01 fan-in）。
 * totalUnread 必須來自 backend；不得在此重算各源。
 */
export function normalizeNotificationCenterUnreadCount(payload) {
  const totalUnread = Number.isFinite(Number(payload?.totalUnread))
    ? Math.max(0, Math.floor(Number(payload.totalUnread)))
    : 0;
  const socialUnread = Number.isFinite(Number(payload?.socialUnread))
    ? Math.max(0, Math.floor(Number(payload.socialUnread)))
    : 0;
  const groupTripUnread = Number.isFinite(Number(payload?.groupTripUnread))
    ? Math.max(0, Math.floor(Number(payload.groupTripUnread)))
    : 0;
  const imUnread = Number.isFinite(Number(payload?.imUnread))
    ? Math.max(0, Math.floor(Number(payload.imUnread)))
    : 0;
  const announcementUnread = Number.isFinite(Number(payload?.announcementUnread))
    ? Math.max(0, Math.floor(Number(payload.announcementUnread)))
    : 0;
  const inboxUnread = Number.isFinite(Number(payload?.inboxUnread))
    ? Math.max(0, Math.floor(Number(payload.inboxUnread)))
    : 0;
  return {
    totalUnread,
    socialUnread,
    socialCapped: Boolean(payload?.socialCapped),
    socialScanTruncated: Boolean(payload?.socialScanTruncated),
    groupTripUnread,
    imUnread,
    announcementUnread,
    inboxUnread,
  };
}

/**
 * Header bell presentation。
 * raw value = totalUnread；99+ 僅為既有 display formatting，不改動 data semantics。
 * socialCapped / socialScanTruncated 不重算 total。
 */
export function badgeFromNotificationCenterUnread(count) {
  if (!count) {
    return { mode: 'hidden', text: '', count: 0, capped: false, scanTruncated: false };
  }
  const total = count.totalUnread;
  const scanTruncated = Boolean(count.socialScanTruncated);
  if (total <= 0) {
    if (scanTruncated) {
      return { mode: 'dot', text: '', count: 0, capped: false, scanTruncated: true };
    }
    return { mode: 'hidden', text: '', count: 0, capped: false, scanTruncated: false };
  }
  // Presentation-only cap for display; count retains backend totalUnread.
  if (total > 99) {
    return { mode: 'capped', text: '99+', count: total, capped: true, scanTruncated };
  }
  return {
    mode: 'exact',
    text: String(total),
    count: total,
    capped: false,
    scanTruncated,
  };
}

export function notificationCenterBadgeAriaLabel(badge, t) {
  if (!badge || badge.mode === 'hidden') {
    return typeof t === 'function' ? t('travel.nav.notificationCenter') : 'Notifications';
  }
  if (badge.mode === 'dot') {
    return typeof t === 'function'
      ? t('travel.socialNotification.badge.hasUnread')
      : 'You have unread notifications';
  }
  if (badge.mode === 'capped') {
    return typeof t === 'function'
      ? formatMessage(t('travel.socialNotification.badge.atLeast'), { count: 99 })
      : 'At least 99 unread notifications';
  }
  return typeof t === 'function'
    ? formatMessage(t('travel.socialNotification.badge.count'), { count: badge.count })
    : `${badge.count} unread notifications`;
}
